import { createSelector } from 'reselect';
import {
    handleRehydrateAction,
    handleRemoveAction,
    handleSubmitAction
} from '../../../core/store/helpers/reducer-helper';
import { VasState } from '../../store/store-type';
import * as account from './account.actions';
import { Account } from './account.model';

export interface State {
    ids: Array<string>;
    entities: {[id: string]: Account};
    selected: string | null;
    selectedPrevious: string | undefined;
}

export const initialState: State = {
    ids: [],
    entities: {},
    selected: undefined,
    selectedPrevious: undefined
};

// tslint:disable-next-line:only-arrow-functions
export function reducer(state = initialState, action: account.Actions): State {
    switch (action.type) {
        case account.SUBMIT: {
            return handleSubmitAction(state, action);
        }
        case account.REHYDRATE: {
            return handleRehydrateAction(state, action);
        }
        case account.REMOVE: {
            return handleRemoveAction(state, action);
        }
        case account.SELECT: {

            if (state.selected === action.payload) {
                return state;
            }

            return {
                ...state,
                selected: action.payload,
                selectedPrevious: state.selected
            };
        }

        default: {
            return state;
        }
    }
}

export const getState = (state: VasState) => state.account;
export const getEntities = createSelector(
    getState,
    state => state.entities
);
export const getIds = createSelector(
    getState,
    state => state.ids
);
export const getSelectedId = createSelector(
    getState,
    state => state.selected
);
export const getSelectedPreviousId = createSelector(
    getState,
    state => state.selectedPrevious
);
export const getCurrentAndPreviousSelectedId = createSelector(
    getSelectedId,
    getSelectedPreviousId,
    (curr, prev) => {
        return {
            selectedPrevious: prev,
            selected: curr
        };
    });
export const getSelected = createSelector(
    getEntities,
    getSelectedId,
    (entities, selectedId) =>
        entities[selectedId]
);
export const getAll = createSelector(
    getEntities,
    getIds,
    (entities, ids) =>
        ids.map(id => entities[id])
);



// WEBPACK FOOTER //
// ./src/vas/business-objects/account/account.reducer.ts